export default {
  getApiUrl(state) {
    return state.apiUrl;
  },
  getGoogleClientId(state) {
    return state.googleClientId;
  },
  getFacebookClientId(state) {
    return state.facebookClientId;
  },
  getCaptchaKey(state) {
    return state.captchaKey;
  },
};
